module.exports = __webpack_public_path__ + "static/andfarr-3772b197bb318356e0298660bd96ee88.mp4";